import { getHttpInstance } from '@app/services/defaultHttpService';
import { replaceTokensInString } from '@app/utils';
import endpoints from '@app/constants/endpoints';

export const getDealerInfo = (storeId, landId) => {
  const http = getHttpInstance();
  return http
    .get(replaceTokensInString(endpoints.DEALER_FIELDS_INFO, storeId, landId))
    .then(response => {
      return response.data;
    });
};
